import {useEffect, useRef, useState} from "react";
import ThumbnailProductItem from "../thumbnailItem/thumbailProductItem";
import {ThumbnailContainerProps} from "./thumbnailContainer.props";
import {ThumbNailProductsContainer} from "./thumbnailContainer.styled";

const ProductsThumbnailContainer: React.FC<ThumbnailContainerProps> = ({
  // setShow,
  bodyContent,
  data,
  isService,
  onchangeService,
}) => {
  const [width, setWidth] = useState<number | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const sortedData = data?.slice().sort((a, b) => {
    const nameA = a.mainServiceName?.toLowerCase() || "";
    const nameB = b.mainServiceName?.toLowerCase() || "";
    return nameA.localeCompare(nameB);
  });
  useEffect(() => {
    if (containerRef.current) {
      setWidth(containerRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (containerRef.current) {
        setWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [data]);

  return (
    <>
      {data && data!.length > 0 ? (
        <ThumbNailProductsContainer ref={containerRef} className="mr-[-10px]">
          {sortedData?.map((item, index) => (
            <ThumbnailProductItem
              key={index} // Use a unique key, such as `item.id`, if available
              bodyContent={bodyContent}
              data={item}
              isService={isService}
              buttonText="View"
              onchangeSelectedService={(e) => {
                onchangeService(e);
              }}
              buttonTextClassName="serviceBtnItem"
              width={Number(width) / 3 - 20}
            />
          ))}
        </ThumbNailProductsContainer>
      ) : null}
    </>
  );
};

export default ProductsThumbnailContainer;
